import { qubitApi } from '@/infrastructure/Configuration'
import { generateID } from '../room-rate-display/helpers/generatorUniqueId'
import { setCookie } from '../../src/infrastructure/Utils'
/**
 * Service Qubit
 */
export default class QubitService {
  constructor (httpClient) {
    this.httpClient = httpClient
    this.urlDataSet = 'https://datasets.qubit.com/v1/owners'
  }

  async newExperience ({ trackingId, experienceIds }) {
    let contextId = ''
    const COOKIE_QTRACKER = global.Cookie.read('_qubitTracker')
    const randomID = generateID()

    if (COOKIE_QTRACKER) {
      contextId = COOKIE_QTRACKER
    } else {
      setCookie('_qubitTracker', randomID, {
        domain: '.radissonhotels.com',
        expires: global.Dates.parseDaysFromTodayToTimestamp(365)
      })
      contextId = global.Cookie.read('_qubitTracker')
    }

    const url = `${qubitApi}/${trackingId}/experiences?contextId=${contextId}&experienceIds=${experienceIds}`
    const { data } = await this.httpClient.get(url)
    console.log('data =>', data)

    return data
  }

  checkExperience ({ checkCallback }) {
    this.httpClient.post(checkCallback)
  }

  async dataSetExperience ({ trackingId, dataset, key }) {
    const url = `${this.urlDataSet}/${trackingId}/datasets/${dataset}/data?id=${key}&streaming=false`
    const { data } = await this.httpClient.get(url)
    return data
  }
}
